import axios from "axios";
import * as Util from "../utility";
import { LocalService } from "./local.service";

/**
 * The app's web checkout (/subscription?key=…, its confirmation and the public
 * invoice) has no login: the signed `key` says who is paying. A 401 there (a
 * route the API doesn't whitelist yet, or a stale token of another web user in
 * this browser) must fail that one call, never log out and send the app user
 * to /login.
 */
const isKeyedCheckoutPage = (): boolean => {
  const path = window.location.pathname;
  return path === '/subscription' || path.startsWith('/subscription/');
};

export class HttpService {
  private http = axios.create();
  private localService = new LocalService();
  private methods = new Util.Methods();

  /*
     If User Header is null then auto set dynamic server header
    */

  // ---------------------------------------------------------------- Dynamic Header / Server Header ----------------------------------------------------------//
  private getHTTPOption(): any {
    let jwtToken: any = "";
    const md5Authorization = this.methods.getAuthKey();
    jwtToken = this.localService.getToken();

    // check for null or unidentified token
    if (
      jwtToken == null ||
      jwtToken === "undefined" ||
      jwtToken === "no token found"
    ) {
      jwtToken = "";
    }

    const httpOptions = {
      headers: {
        Authorization: md5Authorization,
        token: jwtToken,
        "Content-Type": "application/json ; charset=UTF-8",
      },
    };

    return httpOptions;
  }

  //  ---------------------------------------------------------------- Custom Header ---------------------------------------------------------------- //
  private getSMAPIOptions(): any {
    const httpOptions = {
      headers: {
        authorization: "HellowncdgudEkjncinUnjnjcOnc83hnU",
      },
    };

    return httpOptions;
  }

  // ---------------------------------------------------------------- Upload Header ---------------------------------------------------------------- //
  private getUploadingOption(): any {
    let jwtToken: any = "";
    const md5Authorization = this.methods.getAuthKey();
    jwtToken = this.localService.getToken();

    // check for null or unidentified token
    if (
      jwtToken == null ||
      jwtToken === "undefined" ||
      jwtToken === "no token found"
    ) {
      jwtToken = "";
    }

    const httpOptions = {
      headers: {
        Authorization: md5Authorization,
        token: jwtToken,
      },
    };

    return httpOptions;
  };

  //if campaign is without login setToken
  private setCustomToken(token: string): any {
    let jwtToken: any = "";
    const md5Authorization = this.methods.getAuthKey();
    jwtToken = this.localService.getToken();

    // check for null or unidentified token
    if (
      jwtToken == null ||
      jwtToken === "undefined" ||
      jwtToken === "no token found"
    ) {
      jwtToken = token;
    }

    const httpOptions = {
      headers: {
        Authorization: md5Authorization,
        token: jwtToken,
      },
    };

    return httpOptions;
  }

  // ---------------------------------------------------------------- Get Request ---------------------------------------------------------------- //
  // async getRequest(url: string, options: any, key?: string) {
  //   let asyncResult: any;
  //   try {
  //     if (options == null || options === "" || options === "undefined") {
  //       options = this.getHTTPOption();
  //     } else if ((options + "").toString().toLocaleLowerCase() === "file") {
  //       options = this.getUploadingOption();
  //     } else if (options === "sm_api") {
  //       options = this.getSMAPIOptions();
  //     } else if ((options + "").toString().toLocaleLowerCase() === "token") {
  //       options = this.setCustomToken(key ?? '');
  //     }

  //     asyncResult = new Promise(async (resolve, reject) => {
  //       this.http.get(url, options).then(async (response) => {
  //         const token = response.headers['token'];
  //         if ((token + '').toString().toLocaleLowerCase() !== 'undefined') {
  //           this.localService.setToken(token);
  //         };
  //         resolve(response);
  //       }).catch((error) => reject(JSON.stringify(error)));
  //     });

  //     asyncResult = await this.http
  //       .get(url, options)
  //       .catch((e) => console.warn("get Request Error :: " + e));

  //         const token = asyncResult.headers['token'];
  //         if ((token + '').toString().toLocaleLowerCase() !== 'undefined') {
  //           this.localService.setToken(token);
  //         };

  //     if (asyncResult.status >= 400 && asyncResult.status <= 499) {
  //       throw new Error(
  //         "Resource Not found error, Status Code=" + asyncResult.status
  //       );
  //     };
      
  //     return asyncResult.data;
  //   } catch (error) {
  //     throw new Error("Get Request Error :: " + error);
  //   } finally {
  //   }
  // };


  async getRequest(url: string, options: any, key?: string){
    let response:{[key:string]:any} = {};
    try{
      if (options == null || options === "" || options === "undefined") {
        options = this.getHTTPOption();
      } else if ((options + "").toString().toLocaleLowerCase() === "file") {
        options = this.getUploadingOption();
      } else if (options === "sm_api") {
        options = this.getSMAPIOptions();
      } else if ((options + "").toString().toLocaleLowerCase() === "token") {
        options = this.setCustomToken(key ?? '');
      }

      response = await axios.get(url, options);
      
      //save token in local storage
      const token = response.headers['token'];
      if ((token + '').toString().toLocaleLowerCase() !== 'undefined') {
        this.localService.setToken(token);
      };

      response =  response.data;
    } catch (error: any) {
      response["info"] = `Get Request Error ==> ${new Error(error.toString())} stack ==> ${new Error(error.toString()).stack}`;
      const status = error?.response?.status;
      if (status) {
        console.log('error.response.status', status);
        if (status === 401 && !isKeyedCheckoutPage()) {
          this.localService.logout();
          window.location.href = '/login';
        }
      } else {
        console.log('Get Request Network/other error', error);
      }
    } finally {
      return response;
    }
  }

  // ---------------------------------------------------------------- Post Request ----------------------------------------------------------------

  async postRequest(url: string, payload: any, options: any, onUploadProgress?: (percent: number) => void) {
    let result: any;
    try {
      if (options == null || options === "" || options === "undefined") {
        options = this.getHTTPOption();
      } else if ((options + "").toString().toLocaleLowerCase() === "file") {
        options = this.getUploadingOption();
      }

      if (onUploadProgress) {
        options = {
          ...options,
          onUploadProgress: (progressEvent: any) => {
            const total = progressEvent.total || 0;
            const percent = total > 0 ? Math.round((progressEvent.loaded * 100) / total) : 0;
            onUploadProgress(percent);
          },
        };
      }

      result = new Promise(async (resolve, reject) => {
        this.http
          .post(url, payload, options)
          .then((res) => {
            const token = res.headers['token'];
            if ((token + '').toString().toLocaleLowerCase() !== 'undefined') {
              this.localService.setToken(token);
            };
            resolve(res.data)
          })
          .catch((errors) => {
            //handle errors
            console.log(`Request Error HTTPS :: URL(${url}) :: Options(${JSON.stringify(options)}) ERROR :: `, errors)
            const status = errors?.response?.status;
            if (status === 401 && !isKeyedCheckoutPage()) {
              this.localService.logout();
              window.location.href = '/login';
            }
            reject(errors.response || errors)
          });
      });

      return result;
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 401 && !isKeyedCheckoutPage()) {
        this.localService.logout();
        window.location.href = '/login';
      }
      throw error;
    }
  }

  //previous method Post Request
  // async postRequest(url: string, payload: any, options: any) {
  //     let result: any;

  //     try {
  //         if (options == null || options === '' || options === 'undefined') {
  //             options = this.getHTTPOption();
  //         } else if (
  //             (options + '').toString().toLocaleLowerCase() === 'file'
  //         ) {
  //             options = this.getUploadingOption();
  //         }

  //         result = await this.http.post(url, payload, options);

  //         /*
  //         //previous Code

  //         if (result.status >= 400 && result.status <= 499) {

  //             throw new Error(
  //                 'Resource Not found error, Status Code=' + result.status
  //             );
  //         }

  //         const token = result.headers.get('token') + '';
  //         if((token + '').toString().toLocaleLowerCase() !== 'undefined'){
  //             this.localService.setToken(token);
  //         }

  //         */

  //         return result.data;
  //     } catch (error) {}

  // }
}
